/**
 * גשר לתוסף ה-Chrome "מרכזיה — חייגן קליק": מודיע לו כשה-SIP של אפליקציית
 * הווב נרשם/מתנתק, כדי שהתוסף ישהה את הסופטפון שלו רק כשהקו כאן *באמת* רשום
 * (מונע רישום כפול של אותו קו — צלצול כפול / אודיו מפוצל). זהו צד ה-web app של
 * "גישה C". התוסף מאזין ב-onMessageExternal/onConnectExternal.
 *
 * בטוח לחלוטין כשאין תוסף: chrome.runtime לא קיים ברוב הדפדפנים, ו-sendMessage
 * לתוסף שלא מותקן פשוט נכשל בשקט (עוטפים ב-catch). אין תלות ומייל.
 */

// ה-ID היציב של התוסף (נגזר מ-manifest "key"). אות externally_connectable מגיע
// רק מ-merkaziya.kailai.tech (allow-list במניפסט של התוסף).
const EXTENSION_ID = 'dfamjmibohejdefpplkdhacmlbcjlafg';

// heartbeat — התוסף מתעלם מאות ישן מ-90ש (webapp שקרס). שולחים כל 30ש כל עוד רשום.
const HEARTBEAT_MS = 30_000;

interface ChromeRuntimeLike {
  runtime?: { sendMessage?: (id: string, msg: unknown, cb?: (r: unknown) => void) => void };
}
function chromeRuntime(): ChromeRuntimeLike['runtime'] | undefined {
  return (globalThis as unknown as { chrome?: ChromeRuntimeLike }).chrome?.runtime;
}

/** שולח את מצב הרישום הנוכחי לתוסף (no-op בשקט אם אין תוסף/דפדפן). */
export function signalDialerExtension(registered: boolean): void {
  const rt = chromeRuntime();
  if (!rt?.sendMessage) return;
  try {
    rt.sendMessage(EXTENSION_ID, { type: 'WEBAPP_SIP', registered }, () => {
      // בליעת lastError — sendMessage לתוסף שלא מותקן זורק "Could not establish
      // connection" דרך chrome.runtime.lastError; קריאה אליו מנקה את האזהרה.
      void (globalThis as unknown as { chrome?: { runtime?: { lastError?: unknown } } }).chrome?.runtime?.lastError;
    });
  } catch {
    /* אין תוסף — מתעלמים */
  }
}

let heartbeatTimer: ReturnType<typeof setInterval> | null = null;

/**
 * מתחיל heartbeat של "רשום" לתוסף (ומודיע מיד). קורא לזה כשהקו נרשם.
 * מחזיר פונקציית ניקוי שעוצרת את ה-heartbeat.
 */
export function startDialerExtensionHeartbeat(): () => void {
  signalDialerExtension(true);
  if (heartbeatTimer) clearInterval(heartbeatTimer);
  heartbeatTimer = setInterval(() => signalDialerExtension(true), HEARTBEAT_MS);
  return () => {
    if (heartbeatTimer) { clearInterval(heartbeatTimer); heartbeatTimer = null; }
  };
}
